export const fileFolders = [
  {id: 1, label: 'כללי'},
  {id: 2, label: 'משפטי וקנייני'},
  {id: 3, label: 'תכנוני'},
  {id: 4, label: 'רישוי'},
  {id: 5, label: 'תמונות וממצאי ביקור'},
  {id: 6, label: 'סקר מחירים ותחשיב'},
  {id: 7, label: 'תיעוד קשר לקוח'},
]
